import module from 'clientes/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class ClientesBuscarListaComponent {
  data
  admin
  filtro = ''

  constructor ($filter) {
    this.filterBy = $filter('filter')
  }

  $onChanges (changes) {
    if (changes.data && Array.isArray(this.data)) {
      this.data = orderBy(this.data, ['nombre'])
      this.filtrar()
    }
  }

  filtrar () {
    this.resultados = this.filterBy(this.data, this.filtro)
  }
}

module.component('clientesBuscarLista', {
  controller: ClientesBuscarListaComponent,
  template,
  bindings: {
    data: '<',
    admin: '<',
  },
})



// WEBPACK FOOTER //
// ./src/clientes/components/buscar/lista/component.js